const Dashboard = {
  create(node) {
    this.node = node;
  },
};

export default Dashboard;
